import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useLocation, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../Context";
import { Loader, DateToText, Get, priceFormat, numberFormat, totalPrice } from "../inc/Fetch";
import { Config } from '../../inc/Config';
import { Img, AddToCart } from "../components/Elements";
import Product from "../components/product/Product";
import Options from "../components/product/Options";
import NumberCart from "../components/product/Number";
import ErrorPage from "./ErrorPage";
import Ads from "../components/Ads";

import { MdArrowForwardIos } from "react-icons/md";
import { FaSquare } from "react-icons/fa6";

import Header from "./Header";
import Footer from "./Footer";


import './css/Product.css'

export default function Home() {

    const { t } = useTranslation();
    const params = useParams();

	const {siteData, cartData, user} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;
	const [cart, setcart] = cartData;
    const [userinfo, setuserinfo] = user;

    const [mostProducts, setmostProducts] = useState([]);
    const [selectedImg, setselectedImg] = useState(0);
    const [price, setprice] = useState(0);
    const [productOptions, setproductOptions] = useState([]);
    const [fullScreenImg, setfullScreenImg] = useState(false);

    
    async function loadData() {
        let res = await Get('product?_id=' + params?.id);
        return res;
    }
    
    const { data, error, isLoading } = useQuery(params?.id, loadData); 
    
    function addOptions(data) {

        if (data?.val) {
            setproductOptions(p => [...p?.filter(r => r?._id != data?._id), data]);
        } else {
            setproductOptions(p => [...p?.filter(r => r?._id != data?._id)]);
        }
        
    }

    let numOf = productOptions?.filter(p => p?._id == "qnt");
    

    // console.log(cart);
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [params?.id]);

    useEffect(() => {
        setprice(data?.product?.price?.$numberDecimal);
    }, [data?.product?._id]);

    
    useEffect(() => {
        let total = 0;
        let qntTotal = 1;
        let opTotal = 0;
        productOptions?.map((v) => {
            if (v?._id == "qnt") {
                qntTotal = v?.val;
            } else {
                
                if (v?.type == 'count') {
                    opTotal += v?.price * v?.val;
                } else {
                    opTotal += v?.price;
                }
            }
        });
        
        total = (Number(data?.product?.price?.$numberDecimal) + opTotal) * qntTotal;
        setprice(total);
        
    }, [productOptions]);
    

    if (isLoading) {
        return <Loader />;
    }

    if (!data?.product?._id) {
        return <ErrorPage />
    }

    
	return (
		<>
            <Helmet>
                <title>{data?.product?.title}</title>
                <meta name="description" content={data?.product?.full} />
                <meta property="og:title" content={data?.product?.title} />
                <meta property="og:description" content={data?.product?.full} />
                <meta property="og:image" content={`${Config?.imgUrl}/${data?.product?.img}`} />
            </Helmet>

			<Header title={true}/> 

            <nav className='mainWidth pathNames'> 
                <Link to='/'>{t("home")}</Link>
                <MdArrowForwardIos />
                <Link to='/cat'>{t("all_products")}</Link>
                {data?.product?.cats?.map((v, k) => {
                    return (
                        <>
                            <MdArrowForwardIos />
                            <Link to={`/cat/${v?.val}`}>{v?.name}</Link>
                        </>
                    );
                })}
                {/* <MdArrowForwardIos />
                <Link to={`/cat/${data?.product?.cats[0]?.val}`}>{data?.product?.cats[0]?.name}</Link>
                <MdArrowForwardIos />
                <Link>{data?.product?.title}</Link> */}
            </nav>

            <div className='mainWidth productPageBox'>

                <div className={`productImgsBox ${fullScreenImg && "fullScreen"}`}>
                
                    <a onClick={() => setfullScreenImg(p => !p)} className='mainImgBox'>
                        <Img className='mainImg' src={`img/600/${data?.product?.img[selectedImg]}`} /> 
                    </a>

                    <div className='thumbs'>
                        {data?.product?.img?.map((v, k) => {
                            return (
                                <a key={k} onClick={() => setselectedImg(k)}><Img className={k == selectedImg ? 'checked' : 'none'} src={`img/500x500/${v}`} /></a>
                            );
                        })}

                    </div> 
                </div>


                <div className='productInfoBox'>
                    <h1>{data?.product?.title}</h1>
                    <nav className='cats'>
                        {/* {data?.product?.cats?.map((v, k) => {
                            return (
                                <Link to={`/cat/${v?.val}`} key={k}>{v?.name} | </Link>
                            );
                        })} */}

                        <a><FaSquare />{t("added")}: <DateToText time={data?.product?.date} /></a>
                        {data?.product?.qnt < 1000 ? <a><FaSquare />{t("qnt")}: {numberFormat(data?.product?.qnt)}</a> : <a><FaSquare />{t("qnt")}: {t("unlimited")}</a>}
                    </nav>

                    {siteInfo?.settings?.show_prices?.val == 1 || (siteInfo?.settings?.show_prices?.val == 0 && userinfo?._id) ? <dl>
                        <dd>{priceFormat(price)}</dd>
                        <dt>{global.currency}</dt>
                    </dl>: false}

                    {data?.product?.options?.length ? <div className='productOptionsBox'>
                        <strong>{t("extra_options")}</strong>
                        {data?.product?.options?.map((v, k) => {
                            return (
                                <Options 
                                    key={k} 
                                    onChange={(v) => addOptions(v)}
                                    data={v} 
                                />
                            );
                        })}
                    </div>:false }

                    <div className='fullText'>
                        <strong>{t("description")}</strong>

                        <div dangerouslySetInnerHTML={{__html:data?.product?.full }}>
                        </div>
                    </div>


                    <div className='submitBox'>
                        <NumberCart onChange={(v) => addOptions(v)} qnt={data?.product?.qnt} value={numOf?.length ? numOf[0]?.val : 1}/>
                        <AddToCart data={data?.product} options={productOptions} />
                    </div>
                </div>
    
            </div>

            <div className='mainWidth adsBox'>
                {data?.ads?.map((v, k) => {
                    
                    return (
                        <Ads v={v} key={k} />
                    );
                })}
            </div>

            {data?.related?.length ? <div className='homeTopProducts'>

                <div className='titleBox'>
                    <h4>{t("similar_products")}</h4>
                    <h5>{t("similar_products_sub")}<hr /></h5>
                </div>

                <div className='productsBox list4'>
                    {data?.related?.map((v, k) => {
                        return (
                            <Product data={v} key={k} /> 
                        );
                    })}

                </div>
    
            </div>: false }



            <Footer />
		</>
	)
}
